export class SolicitudAjusteCompensacion {
    tipoIdFuncionario: string;
    numeroIdFuncionario: string;
    nombreCompleto: string;
    porcentajeCompensacion: number;
    turno: string;
    fechaInicial: Date;
    fechaFinal: Date;
    estado: string;
}